export default {
  name: 'dn-static',

  data() {
    return {
      tag: null,
      directives: [],
      attributes: {},
      html: null,
      text: null,
    }
  },

  methods: {
    getMyContextValue(str) {
      let value;
      try {
        return eval(`(${str})`);
      } catch(e) {}

      try {
        return function() { return eval(`(this.${str})`); }.call(this);
      } catch(e) {}
    },
  },

  render(h) {
    if (!this.tag) {
      this.tag = this.$el.tagName.toLowerCase();
      this.id = this.$el.id;
      this.staticClass = this.$el.className;
      this.staticStyle = this.$el.getAttribute('style');

      for (let i = 0, attrs = this.$el.attributes, l = attrs.length; i < l; i++) {
        const attr  = attrs[i],
              name  = attr.nodeName,
              value = attr.value;

        if (name === 'is') continue;
        if (name === 'v-html') {
          this.html = value;
          continue;
        }
        if (name === 'v-text') {
          this.text = value;
          continue;
        }

        if (name.indexOf('v-') === 0) {
          this.directives.push({name: name.replace(/^v-/, ''), value});
        } else {
          this.attributes[name] = value;
        }
      }
    }

    let rowHtml;
    if (this.html) {
      rowHtml = this.getMyContextValue(this.html);
    }

    let children = !rowHtml && this.text || this.$slots.default;
    return h(this.tag, {
      attrs: this.attributes,
      directives: this.directives,
      domProps: {
        innerHTML: rowHtml ? rowHtml : undefined,
      },
    }, children);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/statics/Static.js